<template>
  <div>
    <div v-if="innerUrlList.length">
      <div v-if="visible">
        <el-dialog
          class="image-view-dialog"
          :fullScreen="true"
          :appendToBody="true"
          :visible="true"
          width="0"
        >
          <ImageViewer
            v-bind="$attrs"
            :urlList="innerUrlList"
            :on-close="close"
          ></ImageViewer>
        </el-dialog>
      </div>
      <slot name="trigger">
        <el-button @click="showPic" v-bind="innerBtnConfig">{{
          innerBtnConfig.btnText
        }}</el-button>
      </slot>
    </div>
    <div v-else>{{emptyText||'暂无图片'}}</div>
  </div>
</template>

<script>
/**
 * 功能：展示多图片
 * 用法：
 *  template: {
            tpl: ImageViewTemplate,
            valueKey: 'urls'
        }
 * 属性：valueKey array 就是scope.row 上的图片list
 * 支持单张，多张
 * 注意：valueKey 支持路径 具体可以参考lodash get
 */
import { get } from '@lsfe/tools';
import ImageViewer from '../../image/src/image-viewer.vue';

export default {
    name: 'formatImage',
    components: {
        ImageViewer,
    },
    props: {
        value: { type: [Array, String] },
        scope: { type: Object },
        valueKey: {
            type: String,
        },
        btnConfig: {
            type: Object,
            default: () => ({}),
        },
        emptyText: {
            type: String,
            default: ''
        },
    },
    computed: {
        innerUrlList() {
            const { valueKey } = this;
            let imgs = get(this.scope.row || {}, valueKey);
            let showImgs = Array.isArray(imgs) ? imgs : [imgs];
            return showImgs.filter(Boolean);
        },
        innerBtnConfig() {
            return { ...this.btnDefaultConfig, ...this.btnConfig };
        },
    },
    data() {
        return {
            visible: false,
            btnDefaultConfig: {
                type: 'text',
                btnText: '查看图片',
            },
        };
    },
    created() {},
    methods: {
        close() {
            this.visible = false;
        },
        showPic() {
            this.visible = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.image-view-dialog {
  /deep/ {
    .el-dialog__header,
    .el-dialog__body {
      background: transparent !important;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      height: 0;
      padding: 0;
    }
  }
}
</style>
